module.exports = function() {
  return new Worker("./" + "less-transpiler.5cfc7c42.worker.js");
};